import { Injectable, HostListener } from '@angular/core';
import { ArmaRestOrderList } from './classes/json-interface';

/**
 * Composant qui permet de communiquer entre la liste des commande & le décorticage
 */
@Injectable(/*{
  providedIn: 'root'
}*/)
export class DataService {

  private mInfoOrder: ArmaRestOrderList | undefined;

  public setInfoSteelList(infoOrder: ArmaRestOrderList | undefined) {
    this.mInfoOrder = infoOrder;
  }

  public getInfoSteelList() {
    return this.mInfoOrder;
  }

  constructor() {
    this.mInfoOrder = undefined;
  }
}
